var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',[_c('v-toolbar',{attrs:{"dense":""}},[_c('v-toolbar-title',[_vm._v("Stroji")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }